import { ChatUserDetails } from "@virtualprogaming/js-public-sdk";
import { useQuery, UseQueryOptions } from "react-query";

import { useChatApi } from "./useChatApi";

export function useChatUserById(
  id: number,
  options?: UseQueryOptions<ChatUserDetails>
) {
  const api = useChatApi();
  return useQuery({
    queryKey: ["chat-user-by-id", id],
    queryFn: async () => {
      const { data } = await api.getUserById(id);
      return data;
    },
    ...options,
  });
}
